import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SALESIQ_SCRIPT_ID = "zsiqscript";
const SALESIQ_WIDGET_ID = "zsiqwidget";
const SALESIQ_PRE_SCRIPT_ID = "zsiq-pre-script";

const shouldHideWidget = (pathname) => {
  if (pathname === "/admin" || pathname === "/admin/") return true;
  if (pathname.startsWith("/admin")) return true;
  if (pathname.startsWith("/partners/one-pager")) return true;
  return false;
};

const SalesIQChat = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname || "";

    if (shouldHideWidget(pathname)) {
      const existingScript = document.getElementById(SALESIQ_SCRIPT_ID);
      if (existingScript) {
        existingScript.remove();
      }
      const preScript = document.getElementById(SALESIQ_PRE_SCRIPT_ID);
      if (preScript) {
        preScript.remove();
      }
      const widget = document.getElementById(SALESIQ_WIDGET_ID);
      if (widget) {
        widget.remove();
      }
      return;
    }

    if (document.getElementById(SALESIQ_SCRIPT_ID)) {
      return;
    }

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };

    const preScript = document.createElement("script");
    preScript.id = SALESIQ_PRE_SCRIPT_ID;
    preScript.text =
      "window.$zoho=window.$zoho || {}; $zoho.salesiq=$zoho.salesiq||{ready:function(){}}";
    document.body.appendChild(preScript);

    const script = document.createElement("script");
    script.id = SALESIQ_SCRIPT_ID;
    script.src =
      "https://salesiq.zohopublic.com/widget?wc=siq45a74e171dc9357b9af247de93c97c3ebfb3508ee84aab566b1e0e006e64341e";
    script.defer = true;
    document.body.appendChild(script);

    // Inject mobile CSS to prevent the chat bubble covering pricing CTAs
    if (!document.getElementById("zsiq-mobile-fix")) {
      const style = document.createElement("style");
      style.id = "zsiq-mobile-fix";
      style.textContent = `
        @media (max-width: 640px) {
          .zsiq-float { bottom: 72px !important; right: 12px !important; }
          #zsiq_float { bottom: 72px !important; right: 12px !important; }
        }
      `;
      document.head.appendChild(style);
    }
  }, [location.pathname]);

  return null;
};

export default SalesIQChat;
